import axios from "@/api/config";
let api = {
  system,
  generator,
  goodsAgentPrice,
  generatorProperty,
  generatorRule,
  user,
  role,
  resource,
  agentLevel,
  dictionary,
  videoInfo,
  schedule,
  pageWidgetRelation,
  discountCoupon,
  student,
  department,
  agentApp,
  agentAmountLog,
  agentUserInfo,
  agentRoleInfo,
  goodsInfo,
  goodsItem,
  orderInfo,
  teacher,
  campus,
  classroom,
  chapter,
  question,
  chapterMaterials,
  attachment,
  videoCourse,
  signLog,
  plan,
  subjectCourse,
  classInfo,
  scheduleSetting,
  schedulePeriod,
  scheduleObject,
  classInfoOrderInfo,
  scheduleInfo,
  studentCourse,
  examStudent,
  examType,
  examSetting,
  examSettingRelation,
  scoreRule,
  examResult,
  exam,
  liveRoom,
  signInLog,
  xiaoETongLiveInfo,
  liveInfo,
  liveLog,
  liveMaterials,
  information,
  policy,
  classInfoStudent,
  videoMaterials,
  classInfoPhase,
  scheduleRule,
  schoolPage,
  privacyPolicySetting,
  customerServiceSetting,
  generalSetting,
  paymentSetting,
  agentInfo,
  goodsInfoCenter,
  examSettingTeacher,
  homework,
  practice,
  // liveLog,
  // liveEvaluation,
  fodderGroupInfo,
  fodder,
  polyv,
  polyvChannel,
  chapterMaterialsKnowledge,
  empower,
  newsCenter,
  notice,
  schoolPageMenu,
  template,
  schoolPageTemplate,
  shareReferrerLog,
  advertising,
  freeCourses,
  guideEx,
  wxSchoolPage,
  wxSchoolPageTemplate,
  wxSchoolPageMenu,
  pcIndexV3,
  appConfigure,
  classifyManage,
  additionGoodsRelation,
  additionGoods,
  integral,
  integralRule,
  grade,
  project,
  projectPhase,
  projectPhaseItem,
  certificate,
  userCertificate,
  userProject,
  goodsClaimCode,
  updateUserInfo(data) {
    return axios.post(`${process.env.BASE_URL}/system/updateUserInfo`, data);
  },
  uploadFile(data) {
    return axios.post(`${process.env.BASE_URL}/system/uploadFile`, data);
  },
  updateAgentUserInfoMyself(data) {
    return axios.post(
      `${process.env.BASE_URL}/agentUserInfo/updateAgentUserInfoMyself`,
      data
    );
  },
  buyGoodsBatchByAgentUser(data) {
    return axios.post(
      `${process.env.BASE_URL}/agentUserInfo/buyGoodsBatchByAgentUser`,
      data
    );
  },
  aliPayPcPay(data) {
    return axios2.post(`${process.env.BASE_URL}/aliPay/pcPay`, data);
  },
  changeSort(data) {
    return axios.post(`${process.env.BASE_URL}/goodsItem/changeSort`, data);
  },
  logout(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/logout`, data);
  },
  addOrderInfoBatchByStudents(data) {
    return axios.post(
      `${process.env.BASE_URL}/orderInfo/addOrderInfoBatchByStudents`,
      data
    );
  },
  addOrderInfoBatchByMobiles(data) {
    return axios.post(
      `${process.env.BASE_URL}/orderInfo/addOrderInfoBatchByMobiles`,
      data
    );
  },
  addOrderInfoBatchByMobilesPay(data) {
    return axios.post(
      `${process.env.BASE_URL}/orderInfo/addOrderInfoBatchByMobilesPay`,
      data
    );
  },
  getSubjectCourseTreeList(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourse/getSubjectCourseTreeList`,
      {
        params: data
      }
    );
  },
  getSubjectCourseTreeListByAgentId(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourse/getSubjectCourseTreeList`,
      {
        params: data
      }
    );
  },
  getSubjectCourseTreeListPaper(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationSetting/credentials`,
      data
    );
  },
  // 批量下载证书模板
  batchDownloadCertTemp(data) {
    return axios.get(
      `${process.env.BASE_URL}/examinationCredentials/batchPrint`,
      {
        params: data
      }
    );
  },
  getSubjectCourseTreeListEditPaper(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationSetting/editCredentials`,
      data
    );
  },
  //获取考试期数与项目
  getSubjectCourseTreeListTestTime(data) {
    return axios.get(`${process.env.BASE_URL}/examinationSetting/getSubject`, {
      params: data
    });
  },

  //获取详情
  getSubjectCourseTreeListPaperDetail(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationCredentials/pageList`,
      data
    );
  },

  //批量领取
  getSubjectCourseTreeListMassRevice(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationCredentials/updateExaminationCredentialsList`,
      data
    );
  },
  //批量通知
  getSubjectCourseTreeListMassNotice(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationCredentials/batchNotification`,
      data
    );
  },
  //获取证书模板
  getSubjectCourseCertPaper(data) {
    return axios.get(
      `${process.env.BASE_URL}/examinationSetting/getCredentials`,
      {
        params: data
      }
    );
  },
  //上传证书模板
  getSubjectUploadCourseCertPaper(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationSetting/addAttachmentObject`,
      data
    );
  },

  //证书管理批量打印
  getSubjectUploadMassbatchPrint(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationCredentials/batchPrint`,
      {
        data
      }
    );
  },

  //证书领取详情批量打印
  getSubjectUploadMassSinglePrint(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationCredentials/singlePrint`,
      {
        data
      }
    );
  },

  //批量打印证书
  batchPrintProjectCerts(data) {
    return axios.get(
      `${process.env.BASE_URL}/examinationCredentials/singlePrint`,
      {
        params: data
      }
    );
  },
  //获取考试
  getSubjectGetTest(data) {
    return axios.get(`${process.env.BASE_URL}/examinationSetting/getExam`, {
      params: data
    });
  },

  //证书抓拍记录
  getSubjectUploadCaptureRecord(data) {
    return axios.get(`${process.env.BASE_URL}/examinationSetting/getCapture`, {
      params: data
    });
  },

  //抓拍审批
  getSubjectUploadCaptureApprove(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationSetting/updateApprove`,
      data
    );
  },

  getSubjectTreeList(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourse/getSubjectTreeList`,
      {
        params: data
      }
    );
  },
  getAgentInfo(data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentInfo`, {
      params: data
    });
  },
  getAgentInfoById(data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentInfo/${data}`);
  },
  getRegionTree(data) {
    return axios.get(`${process.env.BASE_URL}/region/getRegionTree`, {
      params: data
    });
  },
  getTeacherList(data) {
    return axios.get(`${process.env.BASE_URL}/teacher/getTeacherList`, {
      params: data
    });
  },
  addQuestionBatch(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/addQuestionBatch`,
      data
    );
  },
  addQuestionBatchChapter(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/addQuestionBatchChapter`,
      data
    );
  },
  addQuestionBatchExam(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/addQuestionBatchExam`,
      data
    );
  },
  bindQuestionBatchExam(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/bindQuestionBatchExam`,
      data
    );
  },
  getSubjectCourseAllTree(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourse/getSubjectCourseAllTree`,
      {
        params: data
      }
    );
  },
  getSubjectCourseAgentIdTree(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourse/getSubjectCourseAllTree`,
      {
        params: data
      }
    );
  },
  getSubjectCourseOrganizationTree(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourseOrganization/getSubjectCourseOrganizationTree`,
      {
        params: data
      }
    );
  },

  upload(data) {
    return axios.get(`${process.env.BASE_URL}/upload/stsToken`, {
      params: data
    });
  },
  syncTecentVideo(data) {
    return axios.post(`${process.env.BASE_URL}/fodder/syncTecentVideo`, data);
  },
  getSignature(data) {
    return axios.post(`${process.env.BASE_URL}/fodder/getSignature`, data);
  }
};
export default Object.assign(api);
import empower from "./empower";
import goodsAgentPrice from "./goodsAgentPrice";
import system from "./system";
import generator from "./generator";
import agentLevel from "./agentLevel";
import agentApp from "./agentApp";
import generatorProperty from "./generatorProperty";
import generatorRule from "./generatorRule";
import user from "./user";
import role from "./role";
import resource from "./resource";
import dictionary from "./dictionary";
import schedule from "./schedule";
import department from "./department";
import student from "./student";
import discountCoupon from "./discountCoupon";
import agentAmountLog from "./agentAmountLog";
import agentUserInfo from "./agentUserInfo";
import agentRoleInfo from "./agentRoleInfo";
import pageWidgetRelation from "./pageWidgetRelation";
import goodsInfo from "./goodsInfo";
import goodsItem from "./goodsItem";
import orderInfo from "./orderInfo";
import teacher from "./teacher";
import campus from "./campus";
import videoInfo from "./videoInfo";
import classroom from "./classroom";
import chapter from "./chapter";
import question from "./question";
import chapterMaterials from "./chapterMaterials";
import attachment from "./attachment";
import videoCourse from "./videoCourse";
import signLog from "./signLog";
import plan from "./plan";
import subjectCourse from "./subjectCourse";
import classInfo from "./classInfo";
import scheduleSetting from "./scheduleSetting";
import schedulePeriod from "./schedulePeriod";
import scheduleObject from "./scheduleObject";
import classInfoOrderInfo from "./classInfoOrderInfo";
import scheduleInfo from "./scheduleInfo";
import studentCourse from "./studentCourse";
import examStudent from "./examStudent";
import examSetting from "./examSetting";
import examType from "./examType";
import examResult from "./examResult";
import examSettingRelation from "./examSettingRelation";
import scoreRule from "./scoreRule";
import exam from "./exam";
import signInLog from "./signInLog";
import liveRoom from "./liveRoom";
import xiaoETongLiveInfo from "./xiaoETongLiveInfo";
import liveInfo from "./liveInfo";
import liveLog from "./liveLog";
import liveMaterials from "./liveMaterials";
import information from "./information";
import policy from "./policy";
import classInfoStudent from "./classInfoStudent";
import videoMaterials from "./videoMaterials";
import classInfoPhase from "./classInfoPhase";
import scheduleRule from "./scheduleRule";
import privacyPolicySetting from "./privacyPolicySetting";
import customerServiceSetting from "./customerServiceSetting";
import generalSetting from "./generalSetting";
import paymentSetting from "./paymentSetting";
import agentInfo from "./agentInfo";
import goodsInfoCenter from "./goodsInfoCenter";
import schoolPage from "./schoolPage";
import fodderGroupInfo from "./fodderGroupInfo";
import fodder from "./fodder";
import examSettingTeacher from "./examSettingTeacher";
import polyv from "./polyv";
import polyvChannel from "./polyvChannel";
import homework from "./homework";
import practice from "./practice";
import chapterMaterialsKnowledge from "./chapterMaterialsKnowledge";
import newsCenter from "./newsCenter";
import notice from "./notice";
import template from "./template";
import schoolPageMenu from "./schoolPageMenu";
import schoolPageTemplate from "./schoolPageTemplate";
import shareReferrerLog from "./shareReferrerLog";
import advertising from "./advertising";
import freeCourses from "./freeCourses";
import wxSchoolPage from "./wxSchoolPage";
import wxSchoolPageMenu from "./wxSchoolPageMenu";
import wxSchoolPageTemplate from "./wxSchoolPageTemplate";
import guideEx from "./guide";
import pcIndexV3 from "./pcIndexV3";

import appConfigure from '@/api/appConfigure'

import classifyManage from "./classifyManage";
import additionGoodsRelation from "./additionGoodsRelation";
import additionGoods from "./additionGoods";
import integral from "./integral";
import integralRule from "./integralRule";
import grade from "./grade";
import project from "./project";
import projectPhase from "./projectPhase";
import projectPhaseItem from "./projectPhaseItem";
import certificate from "./certificate";
import userCertificate from "./userCertificate";
import userProject from "./userProject";
import goodsClaimCode from "./goodsClaimCode";



// WEBPACK FOOTER //
// ./src/api/api.js